export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/LayerSwitcher/GPlayerTools.png?49b13e7dc17fd0fbf8836b22ca05eab4";